//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* eslint-disable */
import AQButton from "@/components/Generics/AQButton/AQButton.vue";

const localStreams = [];

export default {
    name: "VideoMobile",
    components: {
        AQButton
    },
    props: {
        stopBtn: { type: Boolean, default: false },
        timeVideo: { type: Number, default: 10 },
        devices: { type: Array, default: () => [] },
        range: { type: Object, default: () => ({}) }
    },
    data() {
        return {
            recording: false,
            retake: false,
            countdown: 0,
            deviceId: null,
            canStop: false,
            allDevices: null
        };
    },
    created() {
        if (this.range && this.range.max) {
            this.MAX_COUNTDOWN = this.range.max;
        } else if (this.timeVideo) {
            this.MAX_COUNTDOWN = this.timeVideo;
        } else {
            this.MAX_COUNTDOWN = 10;
        }

        this.time = null;
    },
    mounted() {
        this.localStream = null;
        this.recorder = null;

        if (!this.devices && !this.allDevices) {
            this.findDevices();
        } else {
            this.streamUserMediaVideo();
        }
    },
    beforeDestroy() {
        localStreams.forEach(stream => {
            if (stream.active) {
                stream.getVideoTracks().forEach(track => track.stop());
            }
        });
        this.close();
    },
    methods: {
        findDevices() {
            const md = navigator.mediaDevices;

            if (md && md.enumerateDevices) {
                md.enumerateDevices().then(devices => {
                    this.allDevices = devices.filter(device => device.kind === "videoinput");
                    this.deviceId = this.allDevices[0].deviceId;
                    this.streamUserMediaVideo();
                });
            }
        },
        onStartRecording() {
            this.$emit("recordingStarted", true);

            this.recorder = RecordRTC(this.localStream, {
                disableLogs: true,
                type: "video"
            });

            this.recording = true;
            this.recorder.startRecording();
            this.startCountdown();
            this.recorder.camera = this.localStream;
        },
        stopVideo() {
            if (this.recorder) {
                this.recorder.stopRecording(this.stopRecordingCallback);
                this.retake = true;
                this.recording = false;
            }
        },
        stopRecordingCallback() {
            const { video } = this.$refs;
            const recordedBlob = this.recorder.getBlob();

            video.controls = true;
            video.src = null;
            video.srcObject = null;
            video.src = URL.createObjectURL(recordedBlob);

            this.$emit("sendBlob", recordedBlob);
            this.resetRecorder();
        },
        resetVideo() {
            const { video } = this.$refs;

            if (this.recorder) {
                this.recorder.stopRecording(this.resetRecorder);
            }

            video.controls = false;
            this.recording = false;
            this.retake = false;
            clearInterval(this.time);
            this.$emit("sendBlob", null);
            this.streamUserMediaVideo();
        },
        resetRecorder() {
            this.recorder.camera.stop();
            this.recorder.destroy();
            this.recorder = null;
        },
        closeModal() {
            this.$emit("closeMobileDialog");
        },
        submitData() {
            this.$emit("submitData");
        },
        retakeVideo() {
            this.resetVideo();
        },
        switchCamera() {
            const deviceToSwitch = this.devices && this.devices.length ? this.devices : this.allDevices;
            if (deviceToSwitch && !this.recording) {
                const indexId = deviceToSwitch.findIndex(element => element.deviceId === this.deviceId);
                if (indexId < deviceToSwitch.length - 1) {
                    const nextDevice = indexId + 1;
                    this.streamUserMediaVideo(deviceToSwitch[nextDevice].deviceId);
                } else {
                    this.streamUserMediaVideo(deviceToSwitch[0].deviceId);
                }
            }
        },
        streamUserMediaVideo(id) {
            const deviceId = this.devices && this.devices[0] && this.devices[0].deviceId ? this.devices[0].deviceId : this.deviceId;

            this.close();
            this.deviceId = id || deviceId;
            localStreams.splice(0, localStreams.length);

            navigator.mediaDevices
                .getUserMedia({
                    video: {
                        width: { ideal: 1280, max: 1280 },
                        height: { ideal: 720, max: 720 },
                        frameRate: { max: 30 },
                        deviceId: this.deviceId
                    }
                })
                .then(stream => {
                    localStreams.push(stream);
                    this.localStream = stream;
                    this.$refs.video.srcObject = this.localStream;
                })
                .catch((err) => err && this.$emit("cameraIsUsed", true));
        },
        close() {
            const closeTracks = stream => stream.getTracks().forEach(track => track.stop());
            const { video } = this.$refs;

            video && video.srcObject && closeTracks(video.srcObject);
        },
        startCountdown() {
            let diff = null;
            this.countdown = this.MAX_COUNTDOWN;

            if (this.range && this.range.max) {
                diff = this.range.max - this.range.min;
            }

            clearInterval(this.time);

            this.time = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                    if (diff && this.countdown <= diff) {
                        this.canStop = true;
                    }
                } else {
                    this.canStop = false;
                    clearInterval(this.time);

                    if (this.recorder && this.recorder.state === "recording") {
                        this.stopVideo();
                    }
                }
            }, 1000);
        }
    }
};

